
//레포트 & 데시보드 라우터
const pubReportRouter = [
    // {
    //     path : '/report',
    //     name : '',
    //     component: () => import('@/views/report/AnnualPerf.vue')  ,
    //     redirect : '/manager/annualPerf',
        
    //     children : [
    //         {
    //             //ex ) 화면 : Yearly Perf. FCST
    //             path : '/annualPerf',
    //             name : 'annualPerf',
    //             component: () => import('@/views/report/AnnualPerf.vue')  ,
    //         }

    //     ]
    // }  

    /* 화면명 : Yearly Perf. FCST  : MRD_RT_001  */
     {
        path: "/publish/rd/MRD_RT_001", 
        name : 'PUB_MRD_RT_001',
        component: () => import('@/views/publish/rd/MRD_RT_001.vue')
    },

    /* 화면명 : BizPlan  : MRD_RT_002  */
    {
        path: "/publish/rd/MRD_RT_002", 
        name : 'PUB_MRD_RT_002',
        component: () => import('@/views/publish/rd/MRD_RT_002.vue')
    },

    /* 화면명 : Monthly Invoice & Cash Flow  : MRD_RT_003  */
    {
        path: "/publish/rd/MRD_RT_003", 
        name : 'PUB_MRD_RT_003',
        component: () => import('@/views/publish/rd/MRD_RT_003.vue')
    },

    /* 화면명 : Profit & Loss  : MRD_RT_004  */
    {
        path: "/publish/rd/MRD_RT_004", 
        name : 'PUB_MRD_RT_004',
        component: () => import('@/views/publish/rd/MRD_RT_004.vue')
    },

    /* 화면명 : Cash Flow  : MRD_RT_005  */
    {
        path: "/publish/rd/MRD_RT_005", 
        name : 'PUB_MRD_RT_005',
        component: () => import('@/views/publish/rd/MRD_RT_005.vue')
    },

    
    /* 화면명 : 대쉬보드1  : MRD_DS_001  */
    {
        path: "/publish/rd/MRD_DS_001", 
        name : 'PUB_MRD_DS_001',
        component: () => import('@/views/publish/rd/MRD_DS_001.vue')
    },

    
    /* 화면명 :  대쉬보드2 : MRD_DS_002  */
    {
        path: "/publish/rd/MRD_DS_002", 
        name : 'PUB_MRD_DS_002',
        component: () => import('@/views/publish/rd/MRD_DS_002.vue')
    }



]
export {pubReportRouter}